<app-sidebar (toggleSideNav)="onToggleSideNav($event)"></app-sidebar>

<div class="body" [ngClass]="getBodyClass()">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" style="position: absolute"></mat-progress-bar>
  <router-outlet></router-outlet>
</div>
